import { Component, OnInit } from '@angular/core';
import { Language } from '../../services/language.service';
import { Localized } from '../../../../objects';
import { MatDialogRef } from '@angular/material/dialog';
import { LectionaryItemName, LectionaryItemNameService } from '../../services/lectionary-item-name.service';
import { LectionaryItemService, LectionaryItem } from '../../services/lectionary-item.service';
import { LectionaryItemTypeService, LectionaryItemType } from '../../services/lectionary-item-type.service';
import { ReligionBranchServiceService, ReligionBranchSummary } from '../../services/religion-branch.service';
import { ApiService } from '../../../../services/api.service';
import { EditEntityBaseClass } from '../EditEntityBaseClass';

@Component({
  selector: 'app-lectionary-item-name-edit',
  templateUrl: './lectionary-item-name-edit.component.html',
  styleUrls: ['./lectionary-item-name-edit.component.css']
})
export class LectionaryItemNameEditComponent extends EditEntityBaseClass  implements OnInit {

  public currentLanguageCode = "eng";
  public currentLanguage: Language;
  public currentLocalizedData: Localized;
  public item: LectionaryItemName;
  public listsLoaded = true;
  public isValidName : boolean = null;
  public validationError: string;

  public lectionaryItemTypes: LectionaryItemType[];
  public religionBranches: ReligionBranchSummary[];

  constructor(
    private dialog: MatDialogRef<LectionaryItemNameEditComponent>,
    private lectionaryItemNameSvc: LectionaryItemNameService,
    private lectionaryItemTypeSvc: LectionaryItemTypeService,
    private religionBranchSvc: ReligionBranchServiceService,
    private apiSvc: ApiService
    ) {
      super();
    }

    public LoadItem(itemId: number) {
      if (itemId) {
        this.lectionaryItemNameSvc.getItem(itemId).then(
          (data: LectionaryItemName) => {
            this.item = data;

            if (this.item.Localized[0].LanguageCode == null) {
              this.item.Localized[0].LanguageCode = "eng";
            } 

            this.currentLocalizedData = this.item.Localized[0];
          }
        )
      } else {
        //This is a new item request
        this.item = new LectionaryItemName();
      }
    }

  ngOnInit() {

    this.listsLoaded = false;

    this.currentLocalizedData = null;
    if (this.item != null && this.item.Localized != null) {
      this.currentLocalizedData = this.item.Localized[0];
    }


    var lectionaryItemTypePromise = this.lectionaryItemTypeSvc.loadEntities().then(
      (data) => {
        this.lectionaryItemTypes = data;
      }
    )

    var religionBranchPromise = this.religionBranchSvc.loadEntities().then(
      (data) => {
        this.religionBranches = data;
      }
    )

    Promise.all([lectionaryItemTypePromise, religionBranchPromise]).then(
      (data) => {
       // console.log("All promises are completed", this.currentLocalizedData, this.CurrentLocalizedData());
        this.listsLoaded = true;
      }
    )


  } 
    
 

  public cancel() {
    this.dialog.close();
  }

  public save() {
    console.log("PreSave LectionaryItemName: ", this.item, this.item.LectionaryItemType);
    this.isValidName = null;

    if (this.item.LectionaryItemType == null) { 
      alert("Please select a LectionaryItemType");
      return;
    }

    this.apiSvc.post("api/lectionaryitemname/preSaveValidationCheck", this.item).subscribe(
      () => {
        console.log("Post preSaveValidationCheck: ", this.item);
        this.postValidationCheckSave();
      },
      (err) => {

        if (err.status == 406) {  
          
          var errorReason = JSON.parse(err._body).reason; 
          var confirmResult = confirm("This name did not pass the validation check... \n\n" + errorReason + "\n\n" + "Do you want to save this anyway?");
          if (confirmResult) {
            this.postValidationCheckSave();
          }

        } else {
          console.log("error", err);
        }

      //  this.isLoading = false;
      }
    );

  }
 

  private postValidationCheckSave() {

    console.log("PostValidation LectionaryItemName: ", this.item, this.item.LectionaryItemType);
    this.apiSvc.post("api/lectionaryitemname/save", this.item).subscribe(
      (data: LectionaryItemName) => {
        this.item = data;
        console.log(data);
        this.dialog.close(data);
      },
      (err) => {

        if (err.status == 406) {  
          var errorReason = JSON.parse(err._body).reason;
          this.validationError = errorReason;
          alert("Invalid request: " + errorReason);
        } else {
          console.log("error", err);
        }

      //  this.isLoading = false;
      }
    );
  }

}


